<template>
  <div class="electronicfence-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true">
          <el-form-item :label="$t('operate.name86')" prop="fenceId">
            <el-input v-model="queryInfo.fenceId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name87')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name88')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name89')" prop="fenceType">
            <el-select :key="'payment-platform-' + $i18n.locale" v-model="queryInfo.paymentPlatform" :placeholder="$t('public.name1')" style="width:100%">
              <el-option
              v-for="item in paymentPlatformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('operate.name90')" prop="searchTime">
          <el-date-picker
            style="width:400px"
            v-model="queryInfo.searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            @change="syncSearchTimeRange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name91')" prop="column1" sortable></el-table-column>
      <el-table-column :label="$t('operate.name92')" prop="column2" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name93')" prop="column3" sortable></el-table-column>
      <el-table-column :label="$t('operate.name94')" prop="column4" sortable></el-table-column>
      <el-table-column :label="$t('operate.name95')" prop="column5" sortable></el-table-column>
      <el-table-column :label="$t('operate.name96')" prop="column6" sortable></el-table-column>
      <el-table-column :label="$t('operate.name97')" prop="column7" sortable>
        <template slot-scope="scope">
          {{ scope.row.column7 | tzDisplay }}
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

/** 演示页：暂无后端 API，本地 mock 数据 + 账号时区时间筛选；接入 API 后替换 getDataList */
const MOCK_TRANSACTION_RECORDS = [
  {
    column1: 'feea43f58aad4e1d83b80c09688270e2',
    column2: 'lsdzs cycling',
    column3: '',
    column4: '1',
    column5: '贝宝',
    column6: 'wx04175952044537d6d59d270fe299cf0000',
    column7: '2024-04-16 06:25:34'
  },
  {
    column1: 'd1b85e2c9f2e4d9681a325ae647b3246',
    column2: 'lsdzs cycling',
    column3: '',
    column4: '1',
    column5: '支付宝',
    column6: 'wx04174352478612ded48f97df639dac0000',
    column7: '2024-08-16 06:25:34'
  },
  {
    column1: '9d9395c664bb4f5f99b677f3bf56f51d',
    column2: 'lsdzs cycling',
    column3: '',
    column4: '1',
    column5: '微信',
    column6: 'wx041753173961810a3517fc8f9f87d70000',
    column7: '2024-12-16 06:25:34'
  }
]

export default {
  computed: {
    ...mapGetters(['userinfo']),
    paymentPlatformOptions () {
      return [
        { label: this.$t('operate.name98'), value: 1 },
        { label: this.$t('operate.name99'), value: 2 },
        { label: this.$t('operate.name100'), value: 3 },
        { label: this.$t('operate.name101'), value: 4 }
      ]
    }
  },
  data() {
    return {
      queryInfo: {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1,
        paymentPlatform: 1,
        searchTime: [],
        startTime: '',
        endTime: ''
      },
      tableLoading: false,
      total: 0,
      allMockData: MOCK_TRANSACTION_RECORDS,
      cachedList: [],
      tableList: [],
      fenceInfoRules: {
        area: [
          {
            required: true,
            message: this.$t('operate.name171'),
            trigger: 'blur'
          }
        ],
        fenceName: [
          {
            required: true,
            message: this.$t('operate.name172'),
            trigger: 'blur'
          }
        ],
        fenceType: [
          {
            required: true,
            message: this.$t('operate.name173'),
            trigger: 'blur'
          }
        ],
        draw: [
          {
            required: true,
            message: this.$t('operate.name174'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {},
  created() {
    this.getDataList()
  },
  mounted() {
  },
  methods: {
    applyAccountTimeQuery() {
      if (this.queryInfo.searchTime && this.queryInfo.searchTime.length === 2) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
        this.queryInfo.startTime = startTime
        this.queryInfo.endTime = endTime
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
    },
    syncSearchTimeRange (val) {
      const { startTime, endTime } = this.$tz.rangeToAccountQuery(val)
      this.queryInfo.startTime = startTime
      this.queryInfo.endTime = endTime
    },
    filterMockRecords(records) {
      let list = records
      if (this.queryInfo.startTime && this.queryInfo.endTime) {
        list = list.filter((row) => {
          const t = row.column7
          return t && t >= this.queryInfo.startTime && t <= this.queryInfo.endTime
        })
      }
      return list
    },
    paginate(list) {
      this.total = list.length
      const start = (this.queryInfo.pageNumber - 1) * this.queryInfo.pageSize
      this.tableList = list.slice(start, start + this.queryInfo.pageSize)
    },
    getDataList() {
      this.queryInfo.pageNumber = 1
      this.applyAccountTimeQuery()
      this.tableLoading = true
      this.cachedList = this.filterMockRecords(this.allMockData)
      this.paginate(this.cachedList)
      this.tableLoading = false
    },
    resetQuery() {
      this.queryInfo = {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1,
        paymentPlatform: 1,
        searchTime: [],
        startTime: '',
        endTime: ''
      }
      this.getDataList()
    },
    // 改每页条数时回到第一页，避免本地 slice 出现空页
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.paginate(this.cachedList)
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.paginate(this.cachedList)
    }
  }
}
</script>
<style lang="scss" scoped>
.electronicfence-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
}
</style>
